export default {
  title: "WHYSECTION.whySectionTitle",
  titleA:"WHYSECTION.whySectionTitleA",
  items: [
    {
      image: require("../images/quality.png"),
      text: "WHYSECTION.whySection1",
      textA: "WHYSECTION.whySection1A",
    },
    {
      image: require("../images/savings.png"),
      text: "WHYSECTION.whySection2",
      textA: "WHYSECTION.whySection2A",
    },
    {
      image: require("../images/good-ratings.png"),
      text: "WHYSECTION.whySection3",
      textA: "WHYSECTION.whySection3A"
    },
    {
      image: require("../images/guarantee.png"),
      text: "WHYSECTION.whySection4",
      textA: "WHYSECTION.whySection4A"
    },
    {
      image: require("../images/no-residue.png"),
      text: "WHYSECTION.whySection5",
      textA: "WHYSECTION.whySection5A"
    },
    {
      image: require("../images/customer-service.png"),
      text: "WHYSECTION.whySection6",
      textA: "WHYSECTION.whySection6A"
    },
  ],
};
